import React, { useEffect, useRef, useState } from "react";

import "./Product_filter.css";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import {
  Brandings,
  getAllCategories,
  getAllColor,
  getAllFrameType,
  getAllGender,
  getAllMaterial,
  getAllShape,
} from "../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";

const Product_filter = ({
  handleFilterReset,
  onFilterChange,
  setPrice,
  filters,
}) => {
  const dispatch = useDispatch();

  const priceRange = useSelector((state) => state.master.price_range);

  const containerRef = useRef(null);

  // ⭐ AUTO SCROLL UP WHEN ACCORDION OPENS
  const handleAccordionOpen = (e) => {
    setTimeout(() => {
      const item = e.target.closest(".accordion-item");
      if (item && containerRef.current) {
        containerRef.current.scrollTo({
          top: item.offsetTop - 20,
          behavior: "smooth",
        });
      }
    }, 200);
  };

  const lowest = Number(priceRange?.lowest_price) || 0;
  const highest = Number(priceRange?.highest_price) || 0;

  const [value, setValue] = useState([lowest, highest]);

  const [category, setCategory] = React.useState([]);

  // filters.priceRange = value;

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPrice(value);
    //  onFilterChange("priceRange", value);
    // onFilterChange("priceRange", newValue);
  };

  const allCategories = useSelector((state) => state.master.categories);
  const allGender = useSelector((state) => state.master.all_gender);
  const allMaterial = useSelector((state) => state.master.all_material);
  const allFrameType = useSelector((state) => state.master.all_frame_type);
  const allColor = useSelector((state) => state.master.all_color);
  const allBrands = useSelector((state) => state.master.brands);
  const allShape = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllGender());

    dispatch(getAllFrameType());

    dispatch(getAllShape());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllMaterial({ category_id: category }));
    dispatch(Brandings({ category_id: category }));
    dispatch(getAllColor({ category_id: category }));
  }, [dispatch, category]);

  return (
    <>
      <section className="Product_filter" ref={containerRef}>
        <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
          <Accordion.Item eventKey="0" onClick={handleAccordionOpen}>
            <Accordion.Header>Product Categories</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allCategories.map((data) => (
                  <div className="fildiv">
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/all-products/filter/Spectacles.png"
                          }
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                      {/* <p className='icnname'><img className='icon' src={process.env.REACT_APP_IMAGE_URL + data?.image} alt='icon' /> <span>{data?.name}</span></p> */}
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        // checked={filters.category === data?.id}
                        checked={filters?.category?.some(
                          (item) => item.id === data?.id,
                        )}
                        onChange={() =>
                          onFilterChange("category", {
                            id: data?.id,
                            name: data?.name,
                          })
                        }
                        onClick={() =>
                          setCategory((prev) => {
                            const prevArr = Array.isArray(prev) ? prev : [];

                            // if already exists → remove
                            if (prevArr.includes(data.id)) {
                              return prevArr.filter((c) => c !== data.id);
                            }

                            // else add (no duplicates)
                            return [...prevArr, data.id];
                          })
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1" onClick={handleAccordionOpen}>
            <Accordion.Header>Gender</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allGender?.map((data) => (
                  <div className="fildiv">
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/all-products/filter/Spectacles.png"
                          }
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        checked={filters.gender.some(
                          (item) => item.id === data?.id,
                        )}
                        onChange={() =>
                          onFilterChange("gender", {
                            id: data?.id,
                            name: data.name,
                          })
                        }

                        // checked={filters.gender.includes(data?.id)}
                        // // checked={filters.gender === data?.name}
                        // onChange={() => onFilterChange('gender', data?.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2" onClick={handleAccordionOpen}>
            <Accordion.Header>Material</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allMaterial?.map((data) => (
                  <div className="fildiv">
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/all-products/filter/Spectacles.png"
                          }
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        checked={filters.material.some(
                          (item) => item.id === data?.id,
                        )}
                        onChange={() =>
                          onFilterChange("material", {
                            id: data?.id,
                            name: data.name,
                          })
                        }
                        // checked={filters.material.includes(data?.id)}
                        // // checked={filters.material === data?.id}
                        // onChange={() => onFilterChange('material', data?.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3" onClick={handleAccordionOpen}>
            <Accordion.Header>Frame Type</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allFrameType?.map((data) => (
                  <div className="fildiv">
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/all-products/filter/Spectacles.png"
                          }
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        checked={filters.frameType.some(
                          (item) => item.id === data?.id,
                        )}
                        onChange={() =>
                          onFilterChange("frameType", {
                            id: data?.id,
                            name: data.name,
                          })
                        }
                        // checked={filters.frameType.includes(data?.id)}
                        // // checked={filters.frameType === data?.id}
                        // onChange={() => onFilterChange('frameType', data?.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4" onClick={handleAccordionOpen}>
            <Accordion.Header>Colour</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allColor?.map((data) => (
                  <div className="fildiv">
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/all-products/filter/Spectacles.png"
                          }
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        checked={filters.colour.some(
                          (item) => item.id === data?.id,
                        )}
                        onChange={() =>
                          onFilterChange("colour", {
                            id: data?.id,
                            name: data.name,
                          })
                        }
                        // checked={filters.colour.includes(data?.id)}
                        // onChange={() => onFilterChange('colour', data?.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5" onClick={handleAccordionOpen}>
            <Accordion.Header>Brands</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allBrands?.map((data) => (
                  <div className="fildiv">
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/all-products/filter/Spectacles.png"
                          }
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        checked={filters.brands.some(
                          (item) => item.id === data?.id,
                        )}
                        onChange={() =>
                          onFilterChange("brands", {
                            id: data?.id,
                            name: data.name,
                          })
                        }
                        // checked={filters.brands.includes(data?.id)}
                        // onChange={() => onFilterChange('brands', data?.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6" onClick={handleAccordionOpen}>
            <Accordion.Header>Frame Shape</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allShape?.map((data) => (
                  <div className="fildiv">
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/all-products/filter/Spectacles.png"
                          }
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        checked={filters.frameShape.some(
                          (item) => item.id === data?.id,
                        )}
                        onChange={() =>
                          onFilterChange("frameShape", {
                            id: data?.id,
                            name: data.name,
                          })
                        }
                        // checked={filters.frameShape.includes(data?.id)}
                        // // checked={filters.frameShape === data?.id}
                        // onChange={() => onFilterChange('frameShape', data?.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7" onClick={handleAccordionOpen}>
            <Accordion.Header>Price Range</Accordion.Header>
            <Accordion.Body>
              <div className="accdata range_bar_holder">
                {/* <Box sx={{ width: 300 }}> */}
                <Slider
                  getAriaLabel={() => "Temperature range"}
                  value={value}
                  onChange={handleChange}
                  valueLabelDisplay="auto"
                  min={Number(priceRange?.lowest_price)}
                  max={Number(priceRange?.highest_price)}
                  // getAriaValueText={valuetext}
                />
                {/* </Box> */}
                <div className="price_labels">
                  <span>₹{value[0]}</span>
                  <span>₹{value[1]}</span>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </section>
    </>
  );
};

export default Product_filter;
